import { render } from "./Person.vue?vue&type=template&id=13911bba&scoped=true"
import script from "./Person.vue?vue&type=script&lang=js"
export * from "./Person.vue?vue&type=script&lang=js"

import "@/assets/css/topicContent.sass?vue&type=style&index=0&id=13911bba&lang=sass&scoped=true"
import "@/assets/css/loading.sass?vue&type=style&index=1&id=13911bba&lang=sass&scoped=true"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13911bba"]])

export default __exports__